import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
// components
import LoadingScreen from '../components/LoadingScreen';
// pages
import MediatorPortalRedirect from '../pages/linguist/MediatorPortalRedirect';
// graphQL
import { GET_MEDIATOR_ASSIGNMENT_REDIRECT } from '../graphQL/queries';

// ----------------------------------------------------------------------
// Il mediatore non ha una password Universe: la sua identità è Supabase, sul
// Portale Mediatori. Ma le email spedite prima del 14/09/2026 — proposta,
// booking e soprattutto CONFERMA dell'incarico — puntano a pagine vendor di
// Universe, che stanno tutte dietro AuthGuard. Senza questo passaggio il
// mediatore sbatte su una login che non può superare, e quel link è l'unico
// che ha in mano.
//
// Qui, PRIMA di mostrargli la login, chiediamo al server una cosa sola: quel
// codice è un'allocazione di mediazione? Se sì lo mandiamo sul portale giusto;
// se no (interprete, id inesistente) la risposta è null e la login compare
// come sempre. Nessun dato dell'incarico attraversa questo controllo.
// ----------------------------------------------------------------------

// Rotte vendor raggiungibili dai link email che possono riguardare un
// mediatore. L'ultimo segmento è l'id dell'allocazione.
const MEDIATION_CAPABLE_PATHS = [
  /^\/vendors\/interpretationAllocationResponse\/([^/]+)\/?$/,
  /^\/vendors\/interpretationProjects\/([^/]+)\/?$/,
  /^\/vendors\/mediationProjects\/([^/]+)\/?$/,
  /^\/vendors\/booking\/([^/]+)\/?$/
];

export function allocationIdFromPath(pathname) {
  for (const pattern of MEDIATION_CAPABLE_PATHS) {
    const match = pathname.match(pattern);
    // "list" non è un id: è la lista progetti di mediazione
    if (match && match[1] !== 'list') return match[1];
  }
  return null;
}

export default function MediationRedirectGate({ children }) {
  const { pathname } = useLocation();
  const allocationId = allocationIdFromPath(pathname);

  const { data, loading } = useQuery(GET_MEDIATOR_ASSIGNMENT_REDIRECT, {
    variables: { allocationId },
    skip: !allocationId,
    fetchPolicy: 'cache-first'
  });

  if (!allocationId) return children;
  if (loading) return <LoadingScreen />;
  if (data?.mediatorAssignmentRedirect) {
    return <MediatorPortalRedirect allocationId={allocationId} />;
  }
  return children;
}

MediationRedirectGate.propTypes = {
  children: PropTypes.node
};
